module.exports = __webpack_public_path__ + "static/media/bg_search_servizi.98eb56ef.jpg";